// TODO put params on the MA export screen in a non-debug fashion
import {Component, ViewChild,ElementRef} from "@angular/core";
import {DialogService} from "../../bootstrap-modal/dialog.service";
import {DialogComponent} from "../../bootstrap-modal/dialog.component";
import "rxjs/add/operator/toPromise";
import {Observable} from "rxjs";
import {ProjectService} from "../../project/project.service";
import {handleErrors} from "../../misc/handle-errors.decorator";
import {toggleLoading} from "../../misc/loading.decorator";
import {CurrencyCodes} from "../../types/currency";
import {ConfirmDialogService} from "../../confirm-dialog/confirm-dialog-service";
import {AppSettingsService} from "../../app-settings/app-settings.service";

import {
  accountDeterminationIdOptionsConst,
  contractAccountCategoryOptionsConst,
  contractAccountPaymentTermOptionsConst,
  correspondenceVariantOptionsConst,
  incomingPaymentMethodValuesConst,
  invoiceDistribuitionMethodConst,
  invoiceSchedulingValuesConst,
  invoiceLanguageValuesConst,
  exchangeRateTypeConst,
  CONTRACT_ACCOUNT_PAYMENT_TERM_OPTIONS_IDS,
} from "../../types/simplify-constants";

import {
  BrokerApiContractAccountDataModel,
  brokerApiContractAccountDataModelFactory,
} from "../../project/project.model";
import {CAAcknowledgmentDialogComponent} from "../../contract-account/ca-acknowledgment-dialog.component";

@Component({
  templateUrl: "./create-contract-account-dialog.template.pug",
  providers: [
    ProjectService,
    ConfirmDialogService,
    AppSettingsService
  ],
})
export class CreateContractAccountDialogComponent
  extends DialogComponent<BrokerApiContractAccountDataModel, any> implements BrokerApiContractAccountDataModel {
  public currency: string;
  public businessPartner: string; // Customer BP ID
  public contractAccountId: string;
  public contractAccountCategory: string;
  public paymentTerms: string;
  public incomingPaymentMethod: string;
  public invoiceDistribuitionMethod: string;
  public exchangeRateType:string="Standard";
  public exchangeRate: string;
  public correspondenceVariant: string;
  public billToParty: string;
  public projectId: string;
  public correspondenceRecipient: string;
  public contractAccountName: string;
  public accountDeterminationId: string;
  public companyCodeGroup: string;
  public standardCompanyCode: string;
  public correspondenceType: string;
  public outgoingPaymentMethod: string;
  public invoiceScheduling: string;
  public invoiceLanguage: string;
  public accountClass: string;
  public alternatePayer: string;
  public incomingCreditCard: string;
  public billingCycle: string;
  public startDateOfFirstBillingPeriod: string;
  public contractAccountNumberInLegacy: string;
  public addressDetails: {
    buildToParty: any;
    alternatePayer: any;
  };
  public error: Error;
  public loading: boolean = false;
  public itsmCustomerId: string;
  public resellerCustomerId: string;
  public opportunityId: string;
  accountDeterminationIdOptions = accountDeterminationIdOptionsConst;
  correspondenceVariantOptions = correspondenceVariantOptionsConst;
  contractAccountCategoryOptions = contractAccountCategoryOptionsConst;
  paymentTermOptions = contractAccountPaymentTermOptionsConst;
  invoiceSchedulingValues = invoiceSchedulingValuesConst;
  incomingPaymentMethodValues = incomingPaymentMethodValuesConst;
  invoiceDistribuitionMethodValues = invoiceDistribuitionMethodConst;
  invoiceLanguageValues = invoiceLanguageValuesConst;
  currencyOptions = CurrencyCodes.map(it => ({id: it, value: it}));
  static pendingCaName: string;
  static projectID: string;
  static existingCaName: string[];
  static defaultCurrency: string;
  public soldToOptions = [];
  public soldToConfigChecked = true;
  public soldToBPID = "";
  public isAlternatePayerDisabled = false;
  public POR773_TMC: boolean;
  public exchangeRateTypeList: string[]=exchangeRateTypeConst;
  public POR507_2_1_TMC:boolean;
  public isDropdownOpen: boolean = false;
  public POR507_TMC:boolean;
  @ViewChild('exchangeRateInput') exchangeRateInput: ElementRef;
  CR978_TMC: boolean;
  setDefaultAccDeterminationId() {
    if (this.accountDeterminationId || !this.contractAccountCategory) return; // Do not overwrite if already set
    this.contractAccountCategoryOptions.forEach((ca) => {
      const {id, defaultAccDeterminationIdTo} = ca;
      if (id === this.contractAccountCategory && defaultAccDeterminationIdTo) {
        this.accountDeterminationId = defaultAccDeterminationIdTo;
      }
    });
  }
  static showDialogModal(dialogService: DialogService, inputs: BrokerApiContractAccountDataModel): Observable<any> {
    if (inputs.contractAccountName && inputs.projectId) {
      this.pendingCaName = inputs.contractAccountName;
      this.projectID = inputs.projectId;
    }
    if(inputs.currency){
      this.defaultCurrency = inputs.currency;
    }
    this.existingCaName = inputs.existingCaName || [];
    return dialogService.addDialog(
      CreateContractAccountDialogComponent,
      inputs,
      {backdropColor: "rgba(0, 0, 0, 0.5)"},
    );
  }
  cancel(): void {
    CreateContractAccountDialogComponent.pendingCaName = "";
    CreateContractAccountDialogComponent.projectID = "";
    this.result = {create: false};
    this.close();
  }
  public updatePaymentTerms(payerBpid) {
    if (this.addressDetails.alternatePayer.length > 1 && payerBpid) {
      this.paymentTerms =
      this.addressDetails.alternatePayer.find(payer => payer.businessPartnerId === payerBpid).paymentTerms ||
       CONTRACT_ACCOUNT_PAYMENT_TERM_OPTIONS_IDS.NT30;
    } else this.paymentTerms = CONTRACT_ACCOUNT_PAYMENT_TERM_OPTIONS_IDS.NT30;
  }
  @toggleLoading()
  @handleErrors()
  public async createContractAccount(): Promise<void> {
    this.CR978_TMC = await this.appSettingsService.getFeaturePermission(
      "CR978_TMC",
      this.projectId,
    );
    if(CreateContractAccountDialogComponent.defaultCurrency !== this.currency){
      const invoiceCurrencyDetails = await this.projectService.getInvoiceCurrency(this.currency,this.projectId);
      if (invoiceCurrencyDetails.status === false && invoiceCurrencyDetails.data === null ) {
        const message = "Currency selected is not a default country's invoice currency, please ensure you select the correct currency";
        const userResponse = await this.confirmDialogService.confirm("Warning", message,"Cancel","Continue");
        if (userResponse) {
          await this.processContractAccount();
        }
      } else {
        await this.processContractAccount();
      }
    }else{
      await this.processContractAccount();
    }
  }

  public async processContractAccount(): Promise<void> {
    // Check if soldToOptions is a multiselect
    if (this.soldToOptions && this.soldToOptions.length > 1) {
      // Check if an option is selected
      // Check if soldToBpid does not match with alternatePayer
       if (this.soldToBPID !== this.businessPartner && this.soldToBPID !== this.alternatePayer) {
        throw new Error('Selected sold-to Bpid does not match with selected BP ID of alternatePayer');
      }
      // this.businessPartner = this.soldToBPID;
     
    } else if (this.soldToOptions && this.soldToOptions.length === 1) {
      // Check if businessPartner has a value
    }

    // TODO check if name already exists either in CA list or pending requests
    const pendingCaName = CreateContractAccountDialogComponent.pendingCaName || "";
    if (pendingCaName && this.contractAccountName !== pendingCaName) {
      const { updated: caUpdateResult } = await this.projectService.updateContractAccount(this.contractAccountName,
        pendingCaName, CreateContractAccountDialogComponent.projectID);
      if (!caUpdateResult) {
        this.error = new Error("An unexpected error occurred while updating ca status.");
      }
    }
    this.error = null;
    this.loading = true;

    if (!this.billToParty && this.addressDetails.buildToParty.length === 1) {
      this.billToParty = this.addressDetails.buildToParty[0].businessPartnerId;
    }
    if (!this.alternatePayer && this.addressDetails.alternatePayer.length === 1) {
      this.alternatePayer = this.addressDetails.alternatePayer[0].businessPartnerId;
    }
    if (!this.invoiceScheduling) {
      throw new Error("Invoice Scheduling is required to create a Contract Account");
    }
    if (CreateContractAccountDialogComponent.existingCaName.includes(this.contractAccountName.toLowerCase())) {
      throw new Error(`Contract account with name ${this.contractAccountName} already exists.`);
    }
    // For exchangeRate validation
     if (this.exchangeRateType === "Custom") {
      if (this.exchangeRate === undefined || this.exchangeRate === "") {
        throw new Error("Exchange Rate is required");
      }
      if (isNaN(Number(this.exchangeRate))) {
        throw new Error("Exchange Rate must be a numeric value");
      }
      if (this.exchangeRate.length > 15) {
        throw new Error("Exchange Rate must not exceed 15 characters");
      }
     } 
    this.setDefaultAccDeterminationId(); // In case the caller entered us in this state
    this.contractAccountName = this.contractAccountName.trim();
    if (this.soldToOptions && this.soldToOptions.length > 1) {
      this.businessPartner = this.soldToBPID;
    }
    this.contractAccountCategory = this.contractAccountCategoryOptions[0].id;
    this.accountDeterminationId = this.accountDeterminationIdOptions[1].id;

    if (this.CR978_TMC) {
      const modalResults = await (CAAcknowledgmentDialogComponent.showDialogModal(
        this.dialogService,
      ).toPromise());
      if (modalResults === false) {
        this.loading = false;
      } else {
        const result = await this.projectService.createContractAccount(brokerApiContractAccountDataModelFactory(this));
        this.result = {
          create: !!result.filename,
          filename: result.filename,
          contractAccountName: this.contractAccountName,
          updatedPendingCaName: pendingCaName,
        };
        this.close();
      }
    } else {
      const result = await this.projectService.createContractAccount(brokerApiContractAccountDataModelFactory(this));
      this.result = {
        create: !!result.filename,
        filename: result.filename,
        contractAccountName: this.contractAccountName,
        updatedPendingCaName: pendingCaName,
      };
      this.close();
    }
  }

  onSoldToBPIDChange() {
    if (this.soldToBPID && this.soldToBPID !== this.businessPartner) {
      this.alternatePayer = this.soldToBPID;
      this.isAlternatePayerDisabled = true;
      this.updatePaymentTerms(this.soldToBPID);
    } else {
      this.isAlternatePayerDisabled = false;
    }
  }

  exchangeRateStatus=false;
  selectExchangeValue(list: string) {
    this.exchangeRateType = list;
    if (this.exchangeRateType === "Custom") {
      this.exchangeRateStatus = true;
      this.isDropdownOpen = false;
      this.exchangeRate = "";
      setTimeout(() => {
        this.exchangeRateInput.nativeElement.focus();
      }, 0);
    } else {
      this.exchangeRateStatus = false;
      this.isDropdownOpen = false;
      this.exchangeRate = "";
    }
  }
  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }
  constructor(
    public dialogService: DialogService,
    private projectService: ProjectService,
    private confirmDialogService: ConfirmDialogService,
    private appSettingsService: AppSettingsService
  ) {
    super(dialogService);
    (async () => {
      const featurePermissions = await this.appSettingsService.getFeaturePermissionsList(["POR773_TMC", "POR507_TMC","POR507-2-1_TMC"]);
      this.POR773_TMC = featurePermissions["POR773_TMC"];
      this.invoiceSchedulingValues = this.POR773_TMC === true ? invoiceSchedulingValuesConst.filter(it => (it.id !== "SH01" && it.id !== "SH02")) : invoiceSchedulingValuesConst;
      this.POR507_TMC= featurePermissions["POR507_TMC"];
      this.POR507_2_1_TMC = featurePermissions["POR507-2-1_TMC"];
      if(this.POR507_2_1_TMC === true){
        const valuesToAdd = ["Daily", "Spot Selling", "Spot Buying", "Custom"];
        valuesToAdd.forEach(value => {
          if (!this.exchangeRateTypeList.includes(value)) {
            this.exchangeRateTypeList.push(value);
          }
        });

        this.exchangeRateType="Standard"; 
      }
    })();
  }
}
